export const log_with_color = (message: string, color: string) => {
  console.log(`%c${message}`, `color:${color}`)
}
